// extracted by mini-css-extract-plugin
export default {"container":"LinkFooter_container__SURBH","links":"LinkFooter_links__v6PQK"};